import { createFileRoute } from "@tanstack/react-router";

import { ORGANIZATIONS_QUERY } from "@/features/organizations/graphql/organizations-query";
import { Organizations } from "@/features/organizations/organizations";

export const Route = createFileRoute("/_authenticated/organizations/")({
  component: Organizations,
  loader: async ({ context }) => {
    if (context.urqlClient) {
      await context.urqlClient.query(ORGANIZATIONS_QUERY, {}).toPromise();
    }
  },
});
